export const ClaimSatus = [
  "incomplete",
  "full",
  "transferred_to_unit",
  "transferred_to_targeted_institution",
  "assigned_to_staff",
  "treated",
  "validated",
  "archived",
  "awaiting",
  "considered",
];
